import React from "react";
import "./howToClaim.scss";

class HowToClaim extends React.Component {
  render() {
    return (
      <div className="howToClaim">
        <h2 className="title">Simple. Fast. Effective</h2>
        <h3 className="sub-title">
          Claims, just like customers, are always a priority at Toffee
          Insurance.
          <br />
          <br />
          Just call a Toffee Claim expert at{" "}
          <span className="font-weight-bold">+91 9389 9389 38</span> or even
          quicker, keep the following documents with you and log in to your
          Toffee Insurance account to file for a claim.
        </h3>
        <hr />
        <div className="d-flex image-text-container">
          <img
            src={require("../../../assets/images/icons/login-icon.svg")}
            alt=""
          />
          <div>
            <h2>Log in</h2>
            <h3>
              Just go to the Toffee Insurance website and log into your account.
            </h3>
          </div>
        </div>
        <div className="d-flex image-text-container">
          <img
            src={require("../../../assets/images/icons/upload-icon.svg")}
            alt=""
          />
          <div>
            <h2>Upload Bills / Reports</h2>
            <h3>
              Upload the copy of all the medical bills and reports required.
            </h3>
          </div>
        </div>
        <div className="d-flex image-text-container">
          <img
            src={require("../../../assets/images/icons/call-icon.svg")}
            alt=""
          />
          <div>
            <h2>Relax we assist you</h2>
            <h3>
              Confused about anything? Just call a Toffee Claim Expert* and have
              step-by-step assistance right away.
            </h3>
          </div>
        </div>
        <div className="d-flex image-text-container">
          <img
            src={require("../../../assets/images/icons/transfer-icon.svg")}
            alt=""
          />
          <div>
            <h2>We Transfer</h2>
            <h3>
              Once you hit submit on the claim, just sit back and relax while we
              get your claim money settled in no time.
            </h3>
          </div>
        </div>
      </div>
    );
  }
}

export default HowToClaim;
